/** Per-device view settings for the live screen (UX §6.2, §9.4).
 *
 * Quiet view, the skipped questions, the default timer and whether the key layer is on belong
 * to *this device* and never sync: the teacher's laptop and their phone may be showing the same
 * session in two different ways on purpose. None of them changes what a student sees.
 */
import { useCallback, useState } from "react";

import { storageKey } from "../product";

export function useDevicePref<T>(name: string, fallback: T): [T, (value: T) => void] {
  const key = storageKey(`live.${name}`);
  const [value, set] = useState<T>(() => {
    try {
      const raw = localStorage.getItem(key);
      return raw === null ? fallback : (JSON.parse(raw) as T);
    } catch {
      return fallback;
    }
  });
  const put = useCallback(
    (next: T) => {
      set(next);
      try {
        localStorage.setItem(key, JSON.stringify(next));
      } catch {
        /* a locked-down browser keeps the setting for this load only */
      }
    },
    [key],
  );
  return [value, put];
}
